import styled from 'styled-components';
import { motion } from 'framer-motion';
import { max, min } from '../../../theme/breakpoints';

export const ContentWrapper = styled(motion.div)`
  background-color: ${({ theme }) => (theme.name === 'uplay' ? theme.colors.OuterSpace : theme.colors.RipeLemon)};
  overflow: hidden;

  > .section-wrapper {
    margin: 0 auto;
    padding: 3.75rem 1rem;

    @media screen and ${min('tablet')} {
      padding: 3.75rem 2.75rem;
    }
    @media screen and ${min('desktop')} {
      padding: 5rem 0 3rem;
    }
  }
`;

export const HeaderSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;

  > h2 {
    text-align: center;
    padding: 0;
    margin: 0;
  }

  > p {
    color: ${({ theme }) => theme.colors.text};
    font-size: 1.125rem;
    line-height: 1.6rem;
    letter-spacing: 0.04rem;
    margin: 0;

    @media screen and ${max('mobile')} {
      font-size: 1rem;
    }
  }
`;

export const PlatformSection = styled.div`
  display: flex;
  align-items: baseline;
  font-size: 1.125rem;
  margin-top: 1rem;

  > p {
    color: ${({ theme }) => theme.colors.text};
    margin-right: 1rem;
    font-size: 1.125rem;
  }
  > span {
    border: 1px solid ${({ theme }) => theme.colors.text};
    padding: 0 7px;
    border-radius: 4px;
  }
`;

export const PlansSection = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0;
`;

export const CancelAnytimeContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CancelAnytimeText = styled.p`
  color: ${({ theme }) => theme.colors.text};
  font-size: 1.125rem;
  margin: 0 0.25rem 0 0;
`;
